/* eslint-disable import/no-cycle */
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import * as types from '../../payment/actionTypes';
import {
  completeStripeOnboardingApi,
  createPaymentApi,
  paymentVerifyApi,
  verifySlugApi,
  verifyStripeOnboardingApi,
  getPaymentHistoryApi,
  getNextPagePaymentHistoryApi,
  getKPIDataApi,
  getPlatformCommissionKpiApi,
} from '../requests/paymentRequests';

import { startLoader, stopLoader } from '../../../utility/commonFunction';
import {
  completeStripeOnboardingSuccess,
  createPaymentLoader,
  paymentStep,
  setBusinessData,
  setPaymentVerifyStatus,
  setUserPaymentDetails,
  setVerifyStripeOnboardingStatus,
  setPaymentHistoryList,
  setVerifySlugStatus,
  setKPISData,
} from '../../payment/actions';
import { setUser } from '../../authentication/actions';
// import { setUser } from '../../authentication/actions';

function* verifySlugHandler(action) {
  yield startLoader('transparent');
  try {
    const { data } = yield call(verifySlugApi, action.payload);

    if (data?.status) {
      yield stopLoader('transparent');
      const businessDataPaylod = {
        business_name: data?.data?.business_name,
        colour: data?.data?.colour,
        id: data?.data?.id,
        logo: data?.data?.logo,
        stripe_status: data?.data?.status,
        stripe_status_label: data?.data?.status_label,
        alma_onboarding_status: data?.data?.alma_onboarding_status,
        alma_onboarding_status_label: data?.data?.alma_onboarding_status_label,
        stripe_installment_payment_methods: data?.data?.stripe_installment_payment_methods,
        payment_features: data?.data?.payment_features,
      };
      yield put(setBusinessData(businessDataPaylod));
      yield put(setVerifySlugStatus(data.status));
    } else {
      yield put(setVerifySlugStatus(data.status));
      yield toast.error(data?.errors?.slug?.[0]);
    }
  } finally {
    yield stopLoader('transparent');
  }
}
function* createPaymentHandler(action) {
  yield startLoader('transparent');
  yield put(createPaymentLoader(true));

  try {
    const { data } = yield call(createPaymentApi, action.payload);
    if (data?.status) {
      yield stopLoader('transparent');
      yield put(paymentStep(2));
      if (data?.data?.payment_method_type === 'alma') {
        window.open(data?.data?.url, '_self');
      } else {
        const paymentDetails = {
          ...data?.data,
          payment_type: action.payload.payment_type,
          amount: action.payload.amount,
        };
        yield put(setUserPaymentDetails(paymentDetails));
      }
    }
  } finally {
    yield put(createPaymentLoader(false));
  }
}

function* paymentVerifyHandler(action) {
  try {
    const { data } = yield call(paymentVerifyApi, action.payload);

    if (data.status) {
      yield stopLoader('transparent');
      if (data?.data?.link?.thankyou_url && data?.data?.link?.thankyou_url?.length > 0 && data?.status) {
        window.location.replace(data.data.link.thankyou_url);
      } else if (data.data.status === 'completed') {
        yield put(paymentStep(3));
      }

      // if (action.payload.navigate) {
      //   action.payload.navigate('');
      // }

      // yield put(paymentStep(3));
      yield put(setPaymentVerifyStatus(data?.status));
    } else {
      toast.error(data?.errors?.form_errors?.id);
    }
  } catch (err) {
    console.log(err);
    yield put(setPaymentVerifyStatus(false));
  } finally {
    yield stopLoader('transparent');
    yield put(createPaymentLoader(false));
  }
}

function* completeStripeOnboardingHandler(action) {
  yield startLoader('transparent');
  try {
    const { data } = yield call(completeStripeOnboardingApi, action.payload);
    if (data.status) {
      yield put(completeStripeOnboardingSuccess(data?.data));
      yield stopLoader('transparent');
    }
  } finally {
    yield stopLoader('transparent');
  }
}
function* getKPIDataHandler(action) {
  const includePlatformCommission = action.payload?.includePlatformCommission === true;
  let merged = {};
  try {
    const { data } = yield call(getKPIDataApi);
    if (data?.status && data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
      merged = { ...data.data };
    }
  } catch (e) {
    // keep partial merge if platform KPI still loads
  }
  if (includePlatformCommission) {
    try {
      const { data } = yield call(getPlatformCommissionKpiApi);
      if (data?.status && Array.isArray(data.data)) {
        const rows = data.data;
        const row =
          rows.find((r) => r.kpi_name === 'total_commissoin' || r.kpi_name === 'total_commission') ||
          rows.find((r) => r.model === 'platform_commission') ||
          rows[0];
        merged.platform_commission_total = row?.value ?? 0;
      }
    } catch (e) {
      // payment page KPIs still work without platform commission
    }
  }
  if (Object.keys(merged).length > 0) {
    yield put(setKPISData(merged));
  }
}
function* verifyStripeOnboardingStatusHandler(action) {
  yield startLoader('transparent');
  try {
    const { data } = yield call(verifyStripeOnboardingApi, action.payload);
    if (data.status && data.data.user.user_business_details?.status === 'connected') {
      yield stopLoader('transparent');
      const modifydata = {
        business_name:
          data?.data?.user?.user_business_details?.business_name || data?.data?.user_business_details?.business_name,
        logo: data?.data?.user?.user_business_details?.logo || data?.data?.user_business_details?.logo,
        colour: data?.data?.user?.user_business_details?.colour || data?.data?.user_business_details?.colour,
        status: data?.data?.user?.user_business_details?.status || data?.data?.user?.user_business_details?.status,
        email: data?.data?.user?.email || data?.data?.email,
        role: data?.data?.user?.role || data?.data?.role,
        slug: data?.data?.links?.[0]?.slug,
      };
      yield put(setUser(modifydata));
      if (data.data.user.user_business_details?.status === 'connected') {
        yield put(setVerifyStripeOnboardingStatus(true));
      }
    } else {
      yield stopLoader('transparent');
      yield put(setVerifyStripeOnboardingStatus(false));
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}
function* getPaymentHistoryListHandler(action) {
  if (action.payload.search) {
    yield delay(1000);
  }
  try {
    yield startLoader('transparent');
    const { data } = yield call(getPaymentHistoryApi, action.payload);

    if (data?.status) {
      yield put(setPaymentHistoryList(data));
      yield stopLoader('transparent');
    } else {
      yield put(setPaymentHistoryList([]));
      yield toast.error(data?.errors?.message);
    }
  } finally {
    yield stopLoader('transparent');
  }
}
function* getNextPaymentHistoryListHandler(action) {
  if (action.payload.search) {
    yield delay(1000);
  }
  try {
    yield startLoader('transparent');
    const { data } = yield call(getNextPagePaymentHistoryApi, action.payload);
    if (data) {
      yield put(setPaymentHistoryList(data));
      yield stopLoader('transparent');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

export default function* paymentSaga() {
  yield takeLatest(types.VERIFY_SLUG, verifySlugHandler);
  yield takeLatest(types.CREATE_PAYMENT, createPaymentHandler);
  yield takeLatest(types.PAYMENT_VERIFY, paymentVerifyHandler);
  yield takeLatest(types.COMPLETE_STRIPE_ONBOARDING, completeStripeOnboardingHandler);
  yield takeLatest(types.VERIFY_STRIPE_ONBOARDING_STATUS, verifyStripeOnboardingStatusHandler);
  yield takeLatest(types.GET_PAYMENT_HISTORY_LIST, getPaymentHistoryListHandler);
  yield takeLatest(types.GET_KPI_DATA, getKPIDataHandler);
  yield takeLatest(types.GET_NEXT_PAYMENT_LIST, getNextPaymentHistoryListHandler);
}
